var render = function render(){var _vm=this,_c=_vm._self._c;return _c('keep-alive',[_c(_vm.currentComponent,{ref:"comp",tag:"component",attrs:{"id":_vm.id},on:{"component-change":_vm.componentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }